module.exports = Object.freeze({
    NONE: 0,
    ENGLISH: 1,
    SPANISH: 2,
    OTHER: 3,
    ALL: 4,

    ARABIC: 5,
    CANTONESE: 6,
    CHINESE: 7,
    FILIPINO: 8,
    FRENCH: 9,
    GERMAN: 10,
    HAITIAN: 11,
    HINDI: 12,
    ITALIAN: 13,
    JAPANESE: 14,
    KOREAN: 15,
    MANDARIN: 16,
    PERSIAN: 17,
    POLISH: 18,
    PORTUGUESE: 19,
    RUSSIAN: 20,
    TAGALOG: 21,
    URDU: 22,
    VIETNAMESE: 23,
    YIDDISH: 24,
    
});